<div class="tw-flex tw-flex-col tw-gap-4">
  <p class="tw-text-sm tw-text-color-text-secondary">
    {{ "autoBudgetPreviewDescription" | i18n }}
  </p>

  <div
    appGlossScroll
    class="tw-flex tw-max-h-[50vh] tw-flex-col tw-gap-3 tw-overflow-y-auto tw-pr-1"
    [attr.inert]="isSubmitting ? '' : null"
    [class.tw-opacity-60]="isSubmitting"
  >
    @for (row of rowControls; track $index; let i = $index) {
      <div
        [formGroup]="row"
        class="tw-flex tw-items-start tw-gap-3 tw-rounded-xl tw-border tw-border-color-border-subtle tw-bg-color-surface-input tw-p-3"
      >
        <input
          type="checkbox"
          formControlName="include"
          [attr.aria-label]="row.value.name"
          class="tw-mt-4 tw-h-4 tw-w-4 tw-shrink-0"
        />
        <div class="tw-flex tw-flex-1 tw-gap-3 sm:tw-flex-col">
          <div class="tw-flex tw-flex-1 tw-flex-col tw-gap-1">
            <app-input
              [label]="'budgetName' | i18n"
              formControlName="name"
              [isRequired]="true"
              [manualTouched]="row.get('name')?.touched"
              [hasError]="isDuplicateName(i)"
            ></app-input>
            @if (isDuplicateName(i)) {
              <span class="tw-text-xs tw-text-dt-text-error">{{ "budgetNameExists" | i18n }}</span>
            }
          </div>
          <app-input
            [label]="'budgetAmount' | i18n"
            type="number"
            [min]="minAmount"
            formControlName="amount"
            [isRequired]="true"
            [manualTouched]="row.get('amount')?.touched"
            class="tw-w-32 sm:tw-w-full"
          ></app-input>
        </div>
      </div>
    }
  </div>

  <div class="tw-mt-2 tw-flex tw-justify-end tw-gap-4">
    <app-gloss-button
      [options]="{
        text: 'cancel' | i18n,
        fullClass:
          'tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-rounded-full tw-bg-color-surface-card tw-shadow-elevation-card',
        isEnabled: true,
        onClick: cancel.bind(this),
      }"
      [fontClass]="'tw-text-color-text-action'"
      class="tw-w-1/3"
    ></app-gloss-button>
    <app-gloss-button
      [options]="{
        text: 'createNBudgetsButtonLabel' | i18n: includedCount,
        fullClass:
          'tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-rounded-full tw-bg-color-action-primary',
        isEnabled: includedCount > 0 && !isSubmitting,
        onClick: confirm.bind(this),
      }"
      [fontClass]="'tw-text-color-text-on-action'"
      class="tw-w-2/3"
    ></app-gloss-button>
  </div>
</div>
